import type { PropsWithChildren } from "react";

export const Section = ({ children }: PropsWithChildren) => (
  <div className="section">{children}</div>
);
